import { useEffect, useRef } from 'react';
import { useFieldGuide } from '@tcc/field-guide';
import { getMessage } from '@tcc/i18n';
import { useFeatureFlags, useLoggedInUser } from '@tcc/shared-data-lib';
import { useWaitForElement } from './useWaitForElement';
import { useFeatureFlagsConfigs, useUserLoggedInConfigs } from '../utils/sharedData';

const FLOW_ID = 'side-nav-first-tour';
const FIRST_TARGET = "[data-test-id='user-profile-menu-popover-trigger']";
const FF_KEY = 'field-guide-side-nav-first-tour';

const commonStyles = {
  options: {
    zIndex: 10000,
    spotlightPadding: 0
  },
};

export const useSideNavFirstTour = () => {
  const { configFlow, startFlow } = useFieldGuide();
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const { isReady } = useWaitForElement(FIRST_TARGET);
  const shown = useRef(false);

  useEffect(() => {
    configFlow(FLOW_ID, {
      steps: [
        {
          target: FIRST_TARGET,
          content: getMessage('sidenav.tour.userProfile'),
          styles: commonStyles
        },
        {
          target: "[data-test-id='sidenav-navigation-links-container']",
          content: getMessage('sidenav.tour.navigationBody'),
          styles: commonStyles
        },
        {
          target: "[data-test-id='information-architecture-collapse-button']",
          content: getMessage('sidenav.tour.collapse'),
          styles: commonStyles
        },
      ],
    });
  }, [configFlow]);

  useEffect(() => {
    const shouldStartFlow = isReady && featureFlags?.[FF_KEY] && !shown.current;

    if (shouldStartFlow) {
      shown.current = true;
      startFlow(FLOW_ID);
    }
  }, [isReady, featureFlags, startFlow, user?.id]);
};
